import { FC, PropsWithChildren } from 'react'
import { AppProvider } from '../context/AppContext'

const RootElement: FC<PropsWithChildren> = ({ children }) => {
  return <AppProvider>{children}</AppProvider>
}

export default RootElement
